import React from 'react';

import { Modal, Button, Title, Group, Stack, Text } from '@mantine/core';
import useDeleteNote from 'hooks/notes/useDeleteNote';
import notificationHandler from 'utils/notifications';

const NoteDeleteModal = ({
  opened,
  noteId,
  toggleDrawer,
}: {
  opened: boolean;
  noteId: string;
  toggleDrawer: () => void;
}): JSX.Element => {
  const { successNotification, errorNotification } = notificationHandler();
  const deleteMutation = useDeleteNote();

  const handleClose = (): void => {
    if (opened) {
      toggleDrawer();
    }
  };

  const handleDelete = (): void => {
    deleteMutation.mutate(noteId, {
      onError: error => {
        errorNotification('Note delete failed', error.response?.data.message);
      },
      onSuccess: () => {
        successNotification('Note delete success', `Note successfully deleted.`);
      },
    });
    handleClose();
  };

  return (
    <Modal
      opened={opened}
      onClose={() => {}}
      size='xs'
      centered
      title={<Title order={4}>Delete Note</Title>}
    >
      <Stack p='md'>
        <Stack spacing={0}>
          <Text color='dimmed' size='sm'>
            Are you sure you want to delete this note?
          </Text>
        </Stack>
        <Group position='right'>
          <Button
            variant='light'
            size='xs'
            radius='md'
            onClick={handleClose}
            disabled={deleteMutation.isLoading}
          >
            Cancel
          </Button>
          <Button
            size='xs'
            radius='md'
            color='red'
            loading={deleteMutation.isLoading}
            onClick={handleDelete}
          >
            Delete
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default NoteDeleteModal;
